import Cookie from '@alife/alpha-cookie';
import { SEARCH_PRODUCT } from '@/utils/page-links';

// @alife/alpha-cookie是纯函数包，可以放心大胆的使用
const LOGIN_LINK = `https://passport.alibaba.com/icbu_login.htm?return_url=${encodeURIComponent(
  location.href,
)}`;

const logOut = (link?: string) => {
  return `https://login.alibaba.com/xman/xlogout.htm?return_url=${encodeURIComponent(
    link || SEARCH_PRODUCT,
  )}`;
};

const isLogin = () => {
  const isLoginCookie = Cookie.get('xman_us_t');
  return isLoginCookie && isLoginCookie.indexOf('sign=y') !== -1;
};

const login = () => {
  if (!isLogin()) {
    location.href = LOGIN_LINK;
    return false;
  }
  return true;
};

const evokeLoginDialog = (cb: Function) => {
  if (window.SCHD_COMS && window.SCHD_COMS.use) {
    // 未登陆，但部署有xman，唤起xman，当前页面弹框登录
    window.SCHD_COMS.use(['xman'], () => {
      const { SCXman } = window.SCHD_COMS;
      const xmanObj = new SCXman.Popup({
        members: 'both',
        // "locale": 'en_US'
      });
      xmanObj.on('LOGIN_SUCCESS', () => {
        // 登陆成功后 进行授权
        cb && cb();
      });

      xmanObj.show();
    });
  } else {
    // 直接进行页面跳转，跳转至登录LP
    location.href = LOGIN_LINK;
  }
};

export { login, evokeLoginDialog, isLogin, LOGIN_LINK, logOut };
